import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'SwitchableContentSelector' })(
  ({ breakpoints, brandType, brandColors, type, typography }) => ({
    title: {
      color: brandColors.primaryMain,
      ...type['56_medium'],
      textWrap: 'pretty',
      marginLeft: typography.pxToRem(36),
      marginRight: typography.pxToRem(36),
      marginBottom: typography.pxToRem(105),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...brandType['heading-xxs'],
        marginBottom: typography.pxToRem(48),
        marginTop: typography.pxToRem(48),
        marginLeft: typography.pxToRem(24),
        marginRight: typography.pxToRem(24),
      },
    },
    buttonsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: typography.pxToRem(12),
      paddingLeft: typography.pxToRem(30),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        display: 'inline-grid',
      },
    },
  })
);

export default useStyles;
